import cytoscape from "cytoscape";


export function styleSex(sex: string): cytoscape.Css.NodeShape {
  switch (sex.toLowerCase()) {
    case "m":
      return "rectangle";
    case "f":
      return "round-rectangle";
    default:
      return "ellipse";
  }
}

export function getBackgroundColor(e: cytoscape.NodeSingular) {
  const tested: boolean = (e.data("tested") as boolean) ?? false;

  if (tested) {
    return "#EFE";
  }

  return "#FFF";
}


export const PedigreeGraphStyles: any[] = [
  {
    selector: "node[type='person']",
    style: {
      "label": "data(label)",
      // "content": "data(label)",
      "font-size": "12px",
      "text-valign": "center",
      "text-halign": "center",
      "background-color": getBackgroundColor,
      "width": 125,
      "shape": (e: cytoscape.NodeSingular) => styleSex(e.data("sex")),
      "border-color": "#000",
      "border-width": 1,
      "border-style": (e: cytoscape.NodeSingular) => (e.data("missing") ? "dotted" : "solid"),
    },
  }, {
    selector: "node:selected",
    style: {
      "background-color": "#DDD",
      "border-color": "#366be1",
    },
  }, {
    selector: "edge",
    style: {
      "curve-style": "taxi",
      "taxi-direction": "downward",
      // "control-point-step-size": 20,
      "target-arrow-shape": "triangle",
      "line-style": (e) => (e.data("questioned") ? "dotted" : "solid"),
      "line-dash-pattern": [6, 3],
      "source-endpoint": "180deg",
      "target-endpoint": "0deg",
      // "source-endpoint": "outside-to-node",
      // "target-endpoint": "outside-to-node"
    },
  }, {
    selector: ".eh-handle",
    style: {
      "background-color": "red",
      "width": 12,
      "height": 12,
      "shape": "ellipse",
      "overlay-opacity": 0,
      "border-width": 12, // makes the handle easier to hit
      "border-opacity": 0,
    },
  }, {
    selector: ".eh-hover",
    style: {
      "background-color": "red",
    },
  },

  {
    selector: ".eh-source",
    style: {
      "border-width": 2,
      "border-color": "red",
    },
  }, {
    selector: ".eh-target",
    style: {
      "border-width": 2,
      "border-color": "red",
    },
  }, {
    selector: ".eh-preview, .eh-ghost-edge",
    style: {
      "background-color": "red",
      "line-color": "red",
      "target-arrow-color": "red",
      "source-arrow-color": "red",
    },
  }, {
    selector: ".eh-ghost-edge.eh-preview-active",
    style: {
      opacity: 0,
    },
  },
];
